<script lang="ts">
import EditorStore, { EditorPlaybackControlOwnership } from "@src/model/Editor.Store";

import MainStore from "@src/model/Main.Store";

import { onDestroy, onMount } from "svelte";

export let maxWidth: string = '100%';
export let maxHeight: string = '100%';
export let noControl: boolean = false;

let videoElement: HTMLVideoElement;
let loaded: boolean = false;
let src: string = '';


function handleVideoLoaded(e) {
    if (videoElement.videoWidth > videoElement.videoHeight) {
        videoElement.style.setProperty('width', maxWidth);
    } else {
        videoElement.style.setProperty('height', maxHeight);
    }
    MainStore.setVideoLength(videoElement.duration);
    loaded = true;
}

function handleTimeUpdate(e) {
    MainStore.setVideoTimeStamp(videoElement.currentTime);
}

let interval: any;
function handlePlay(e) {
    interval = setInterval(() => {
        MainStore.setVideoTimeStamp(videoElement.currentTime);
    }, 16);
}
function handlePause(e) {
    clearInterval(interval);
}
function handleEnded(e) {
    clearInterval(interval);
}

let subscribeList: any[] = [];
onMount(() => {
    videoElement.addEventListener('canplaythrough', handleVideoLoaded);
    MainStore.getValue()._currentVideoElement = videoElement;
    subscribeList.push(
        MainStore.getValue().currentVideoTimeStamp.subscribe((n) => {
            if (EditorStore.getValue().currentPlaybackControlOwnership !== EditorPlaybackControlOwnership.CONTROL) {
                videoElement.currentTime = n;
            }
        }),
        MainStore.getValue().currentVideoSource.subscribe((v) => {
            src = v;
        }),
    );
});
onDestroy(() => {
    subscribeList.forEach((v) => v());
});

</script>

<div id="main-video-player">
    <video src={src} id="main-video" bind:this={videoElement}
        on:timeupdate={handleTimeUpdate}
        on:play={handlePlay}
        on:pause={handlePause}
        on:ended={handleEnded}
    >
        <track kind="captions">
    </video>
    {#if loaded}
        <div id="main-video-player-waiting-screen">
            Loading...
        </div>
    {/if}
</div>


<style>
    #main-video-player {
        position: fixed;
        background-color: black;
        z-index: 500;
    }
    #main-video {
        position: fixed;
        background-color: black;
        z-index: 1000;
    }
    #main-video-player-waiting-screen {
        z-index: 1050;
        background-color: black;
        color: white;
        width: 100%;
        height: 100%;
    }
</style>
